import React, { useEffect, useRef, useState } from "react";

export const Lightbox = ({ items = [], startIndex = 0, onClose }) => {
  const [index, setIndex] = useState(Math.max(0, Math.min(startIndex, items.length - 1)));
  const overlayRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  useEffect(() => {
    // use setIndex directly here to avoid missing-deps for next/prev
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") {
        setIndex((i) => (i < items.length - 1 ? i + 1 : i));
      }
      if (e.key === "ArrowLeft") {
        setIndex((i) => (i > 0 ? i - 1 : i));
      }
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden"; // prevent background scroll
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose, items.length]);

  const prev = () => setIndex((i) => (i > 0 ? i - 1 : i));
  const next = () => setIndex((i) => (i < items.length - 1 ? i + 1 : i));

  const onOverlayClick = (e) => {
    if (e.target === overlayRef.current) onClose();
  };

  const onTouchStart = (e) => {
    touchStartX.current = e.touches ? e.touches[0].clientX : e.clientX;
  };
  const onTouchMove = (e) => {
    touchEndX.current = e.touches ? e.touches[0].clientX : e.clientX;
  };
  const onTouchEnd = () => {
    const delta = touchStartX.current - touchEndX.current;
    if (Math.abs(delta) > 30) {
      if (delta > 0) next();
      else prev();
    }
    touchStartX.current = 0;
    touchEndX.current = 0;
  };

  if (!items || items.length === 0) return null;

  const item = items[index];

  return (
    <div
      className="react-lightbox-overlay"
      ref={overlayRef}
      onClick={onOverlayClick}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <div className="react-lightbox-wrap">
        <button className="react-lightbox-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <button className="react-lightbox-prev" onClick={prev} aria-label="Previous" disabled={index === 0}>
          ‹
        </button>
        <div className="react-lightbox-content">
          <div className="react-lightbox-image">
            <img src={item.largeImage} alt={item.title} />
            <div className="react-lightbox-caption">
              <h4>{item.title}</h4>
            </div>
          </div>
        </div>
        <button className="react-lightbox-next" onClick={next} aria-label="Next" disabled={index === items.length - 1}>
          ›
        </button>

        {/* Thumbnails intentionally omitted: only arrows, close and image are shown */}
      </div>
    </div>
  );
};
